import { Col, Tab } from '@rematter/ui-web';

import { useSettingsLocation } from '../../_state/settingsModule.state';
import { SettingsSubmodule } from '../_layouts/SettingsSubmodule';

import { CustomerPortalRolesTabView } from './_CustomerPortalRolesTabView';
import { CustomerPortalUsersTabView } from './_CustomerPortalUsersTabView';

import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export const CustomerPortalRootView = () => {
  const t = useTranslations();
  const [location, setLocation] = useSettingsLocation();

  const isRolesTab =
    location === '/customer-portal' || location === '/customer-portal/roles';
  const isUsersTab = location === '/customer-portal/users';

  return (
    <Col className="@CustomerPortalRootView h-full">
      <SettingsSubmodule
        title={t.customerPortal.title}
        subtitle={t.customerPortal.subtitle}
        tabs={
          <>
            <Tab
              selected={isRolesTab}
              onClick={() => setLocation('/customer-portal/roles')}
            >
              {t.customerPortal.tabs.roles}
            </Tab>
            <Tab
              selected={isUsersTab}
              onClick={() => setLocation('/customer-portal/users')}
            >
              {t.customerPortal.tabs.users}
            </Tab>
          </>
        }
      >
        {isRolesTab && <CustomerPortalRolesTabView />}
        {isUsersTab && <CustomerPortalUsersTabView />}
      </SettingsSubmodule>
    </Col>
  );
};
